export default "__VITE_ASSET__Ko5libiQ__"